import React from "react";

const Back = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
    >
      <path
        d="M11.67 1.4303L9.89 0L0 8L9.9 16L11.67 14.5697L3.54 8L11.67 1.4303Z"
        fill="#C1C1C1"
      />
    </svg>
  );
};

export default Back;
